const getQueryString = (params) => {
  return Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + params[k])
    .join('&');
};

const buildHeaders = (authToken) => {
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
  if (authToken) {
    headers['X-Auth-Token'] = authToken;
  }
  return headers;
}

const apiGet = (url, authToken) => {
  return fetch(url, {
    method: 'GET',
    headers: new Headers(buildHeaders(authToken)),
  }).then((response) => {
    if (!response.ok) {
      return { hasError: true };
    }
    return response.json().then((json) => {
      return {
        hasError: false,
        json,
      };
    });
  });
}

const apiPost = (url, data, authToken) => {
  return fetch(url, {
    method: 'POST',
    headers: new Headers(buildHeaders(authToken)),
    body: JSON.stringify(data)
  });
};

export {
  apiGet,
  apiPost,
  getQueryString,
}
